<script lang="ts">
  import { page } from '$app/state';

  import type { Collection } from '@agapi/mlc-core';
  import { Breadcrumb, BreadcrumbItem } from '@agapi/ui/breadcrumb';
  import { Expandable } from '@agapi/ui/expandable';
  import { Section } from '@agapi/ui/section';
  import { Image } from '@agapi/ui/image';
  import { css } from '@agapi/ui/panda/css';

  import ChildCollections from './child-collections.svelte';
  import Markdown from '../../markdown/markdown.svelte';

  import { BreadcrumbsSchema } from '../../';
  import { collectionHeaderStyles } from './collection-header.styles';
  import { isHTML, isMarkdown } from '../../../utils/formatting.client';
  import { rewriteUrl } from '../../../utils';

  import * as m from '$lib/parachute/messages';

  const { collection }: { collection: Collection } = $props();
  const classes = collectionHeaderStyles.raw();
</script>

<Section colorVariant="primary.subdued" containerWidth="normal" rootStyles={classes.root}>
  <div class={css(classes.contentWrapper)}>
    <div class={css(classes.content)}>
      {#if collection?.breadcrumbs && collection.breadcrumbs.length > 0}
        <BreadcrumbsSchema
          items={collection.breadcrumbs.map((breadcrumb: { label: string; path: string }) => ({
            name: breadcrumb.label,
            item: rewriteUrl(page, breadcrumb.path)
          }))}
        />
        <Breadcrumb css={{ color: 'surface.primary.subdued.foreground', opacity: 0.9 }}>
          {#each collection.breadcrumbs as breadcrumb, index}
            <BreadcrumbItem {index}>
              <a
                href={rewriteUrl(
                  page,
                  index > 0 && page.url.pathname !== breadcrumb.path ? breadcrumb.path : undefined
                )}
              >
                {breadcrumb.label}
              </a>
            </BreadcrumbItem>
          {/each}
        </Breadcrumb>
      {/if}
      <div>
        <h1 class={css(classes.title)}>{collection.name}</h1>
        {#if collection.description && collection.description !== '#N/A'}
        {#key collection.description}
          <Expandable
            showLabel={m.readMore()}
            hideLabel={m.hide()}
            initialHeight={85}
            buttonVariant="secondary"
          >
            <div class={css(classes.description)}>
              {#if isHTML(collection.description)}
                {@html collection.description}
              {:else if isMarkdown(collection.description)}
                <Markdown value={collection.description} />
              {:else}
                {collection.description}
              {/if}
            </div>
          </Expandable>
        {/key}
        {/if}
      </div>
    </div>
    {#key collection.imageUrl}
      {#if collection.imageUrl}
        <Image
          src={collection.imageUrl}
          alt={m.categoryImageAlt({ category: collection.name })}
          css={classes.image}
          background={collection.imageUrl + '?width=8'}
          width={400}
          loading="eager"
          aspectRatio={2 / 1}
        />
      {/if}
    {/key}
  </div>

  <ChildCollections
    isBigger={collection.name === m.campaigns()}
    parent={collection.parent}
    childCollections={collection.childCollections ?? []}
  />
</Section>
